import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postBlacklistDomainSlice = createApi(`PostBlacklistDomainSlice`,"POST");

const PostBlacklistDomainSlice = createSlice({
  name: 'PostBlacklistDomainSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postBlacklistDomainSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postBlacklistDomainSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postBlacklistDomainSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostBlacklistDomainSlice.reducer;